import React from 'react'
import styled from 'styled-components'
import { vc_base, vc_color } from '../../assets/js/Brand'
import { media } from '../../assets/js/Helper'

// components
import Caption from '../atoms/BaseCaption'
import Anchor from '../atoms/BaseAnchor'

// template
const TheRole = (props) => {
  return (
    <Role>
      <RoleTitle>対象ユーザー</RoleTitle>
      <RoleBox>
        <tbody>
          <tr>
            <RoleHead>
              <Anchor to={`/roles/owner`}>
                <Caption type={'span'} className="anchor-text">
                  契約担当者
                </Caption>
              </Anchor>
            </RoleHead>
            <RoleHead>
              <Anchor to={`/roles/subowner`}>
                <Caption type={'span'} className="anchor-text">
                  サブ契約担当者
                </Caption>
              </Anchor>
            </RoleHead>
            <RoleHead>
              <Anchor to={`/roles/manager`}>
                <Caption type={'span'} className="anchor-text">
                  サイト管理者
                </Caption>
              </Anchor>
            </RoleHead>
            <RoleHead>
              <Anchor to={`/roles/user`}>
                <Caption type={'span'} className="anchor-text">
                  サイトユーザー
                </Caption>
              </Anchor>
            </RoleHead>
            <RoleHead>
              <Anchor to={`/roles/nyuko`}>
                <Caption type={'span'} className="anchor-text">
                  入稿担当者
                </Caption>
              </Anchor>
            </RoleHead>
          </tr>
          <tr>
            <RoleBody>
              <Caption>{props.roleData.owner}</Caption>
            </RoleBody>
            <RoleBody>
              <Caption>{props.roleData.subowner}</Caption>
            </RoleBody>
            <RoleBody>
              <Caption>{props.roleData.manager}</Caption>
            </RoleBody>
            <RoleBody>
              <Caption>{props.roleData.user}</Caption>
            </RoleBody>
            <RoleBody>
              <Caption>{props.roleData.nyuko}</Caption>
            </RoleBody>
          </tr>
        </tbody>
      </RoleBox>
    </Role>
  )
}

export default TheRole

// style
const Role = styled.div`
  width: 100%;
  ${media.Minimum`
		display: flex;
	`}
`
const RoleTitle = styled(Caption)`
  font-weight: bold;
  margin-bottom: ${vc_base.pixel};
  max-width: 100%;
  white-space: nowrap;
  width: 100%;
  ${media.Minimum`
		width: 	100%;
		max-width: 20%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-top: 1px solid ${vc_color.border};
		border-bottom: 1px solid ${vc_color.border};
		border-left: 1px solid ${vc_color.border};
		background: ${vc_color.bg_light};
		margin-bottom: 0;
		padding-top: ${vc_base.pixel};
		padding-bottom: ${vc_base.pixel};
		padding-left: ${vc_base.pixel`2.5`};
		padding-right: ${vc_base.pixel`2.5`};
	`}
`
const RoleBox = styled.table`
  border-bottom: 1px solid ${vc_color.border};
  border-right: 1px solid ${vc_color.border};
  max-width: 100%;
  text-align: center;
  width: 100%;
  ${media.Minimum`
		width: 	100%;
		max-width: 80%;
	`}
`
const RoleHead = styled.th`
  background: ${vc_color.bg_light};
  border-left: 1px solid ${vc_color.border};
  border-top: 1px solid ${vc_color.border};
  font-weight: normal;
  padding-bottom: ${vc_base.pixel`0.5`};
  padding-left: ${vc_base.pixel};
  padding-right: ${vc_base.pixel};
  padding-top: ${vc_base.pixel`0.5`};
  vertical-align: middle;
`
const RoleBody = styled.td`
  border-left: 1px solid ${vc_color.border};
  border-top: 1px solid ${vc_color.border};
  padding-bottom: ${vc_base.pixel`0.5`};
  padding-left: ${vc_base.pixel};
  padding-right: ${vc_base.pixel};
  padding-top: ${vc_base.pixel`0.5`};
  vertical-align: middle;
`
